<script>
// 元件 components 內容
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 預設拖曳元件列表
      components: [
        {
          type: 'signature',
          name: '簽名框',
          dataPoint: [],
          signedPhoto: undefined,
          width: 250,
          height: 70
        },
        {
          type: 'input',
          value: '輸入',
          inputType: 'input',
          name: '文字',
          width: 250,
          height: 40
        },
        {
          type: 'input',
          inputType: 'checkbox',
          name: '複選框',
          label: '',
          width: 30,
          height: 30
        },
        {
          type: 'input',
          inputType: 'radio',
          name: '單選框',
          label: '',
          width: 30,
          height: 30
        },
        {
          type: 'container',
          name: '容器',
          width: 300,
          height: 300,
          children: []
        }
      ]
    }
  },
  mounted: function () {
    let borderColor = '#be8f05'
    let color = '#FFE48F'
    if (this.type === 'Main Signer') {
      // 設定禁用狀態 - true:設計模板時, false:可編輯
      this.components = [
        {
          disabled: true,
          type: 'signature',
          usertype: this.type,
          name: '簽名框',
          dataPoint: [],
          signedPhoto: undefined,
          width: 250,
          height: 70,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'date',
          usertype: this.type,
          placeholder: '簽署日期',
          fieldname: 'DateofSignature',
          inputType: 'datetime',
          name: '簽署日期',
          width: 250,
          height: 45,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '姓名',
          fieldname: 'Name',
          inputType: 'input',
          name: '姓名',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '病歷號',
          fieldname: 'MedicalRecordNo',
          inputType: 'input',
          name: '病歷號',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '身分證字號',
          fieldname: 'IDnumber',
          inputType: 'input',
          name: '身分證字號',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'date',
          usertype: this.type,
          placeholder: '出生日期',
          fieldname: 'Dateofbirth',
          inputType: 'date',
          name: '出生日期',
          width: 250,
          height: 45,
          color: color,
          borderColor: borderColor
        },
        //   TODO: iPad 顯示上有 Bug，暫時先註解掉
        // {
        //   disabled: true,
        //   type: 'sex',
        //   usertype: this.type,
        //   name: 'Sex',
        //   value: undefined,
        //   width: 250,
        //   height: 40,
        //   color: color,
        //   borderColor: borderColor
        // },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '地址',
          fieldname: 'Address',
          inputType: 'input',
          name: '地址',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '電話',
          fieldname: 'Phone',
          inputType: 'input',
          name: '電話',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        //   TODO: iPad 顯示上有 Bug，暫時先註解掉
        // {
        //   disabled: true,
        //   type: 'relationshiptopatient',
        //   usertype: this.type,
        //   value: '本人',
        //   signername: '',
        //   relationship: '',
        //   name: 'Relationship To patient',
        //   width: 300,
        //   height: 65,
        //   color: color,
        //   borderColor: borderColor
        // },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'checkbox',
          name: '複選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'radio',
          name: '單選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'container',
          usertype: this.type,
          name: '容器',
          width: 300,
          height: 300,
          children: [],
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '請輸入',
          fieldname: undefined,
          inputType: 'input',
          name: '文字',
          width: 350,
          height: 40,
          color: color,
          borderColor: borderColor
        }
      ]
    } else if (this.type === 'Doctor') {
      borderColor = '#be8f05'
      color = '#AFF995'
      this.components = [
        {
          disabled: true,
          type: 'signature',
          usertype: this.type,
          name: '簽名框',
          dataPoint: [],
          signedPhoto: undefined,
          width: 250,
          height: 70,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'date',
          usertype: this.type,
          placeholder: '簽署日期',
          fieldname: 'DateofSignature',
          inputType: 'datetime',
          name: '簽署日期',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '姓名',
          fieldname: 'Name',
          inputType: 'input',
          name: '姓名',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '身分證字號',
          fieldname: 'IDnumber',
          inputType: 'input',
          name: '身分證字號',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'checkbox',
          name: '複選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'radio',
          name: '單選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'container',
          usertype: this.type,
          name: '容器',
          width: 300,
          height: 300,
          children: [],
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '請輸入',
          fieldname: undefined,
          inputType: 'input',
          name: '文字',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        }
      ]
    } else {
      if (this.type === 'Witness1') {
        borderColor = '#be8f05'
        color = '#8FF2FF'
      } else if (this.type === 'Witness2') {
        borderColor = '#be8f05'
        color = '#B4C7E7'
      }

      this.components = [
        {
          disabled: true,
          type: 'signature',
          usertype: this.type,
          name: '簽名框',
          dataPoint: [],
          signedPhoto: undefined,
          width: 250,
          height: 70,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'date',
          usertype: this.type,
          placeholder: '簽署日期',
          fieldname: 'DateofSignature',
          inputType: 'datetime',
          name: '簽署日期',
          width: 250,
          height: 45,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '姓名',
          fieldname: 'Name',
          inputType: 'input',
          name: '姓名',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '身分證字號',
          fieldname: 'IDnumber',
          inputType: 'input',
          name: '身分證字號',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'date',
          usertype: this.type,
          placeholder: '出生日期',
          fieldname: 'Dateofbirth',
          inputType: 'date',
          name: '出生日期',
          width: 250,
          height: 45,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '地址',
          fieldname: 'Address',
          inputType: 'input',
          name: '地址',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '電話',
          fieldname: 'Phone',
          inputType: 'input',
          name: '電話',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        },
        //   TODO: iPad 顯示上有 Bug，暫時先註解掉
        // {
        //   disabled: true,
        //   type: 'relationshiptopatient',
        //   usertype: this.type,
        //   value: '本人',
        //   signername: '',
        //   relationship: '',
        //   name: 'Relationship To patient',
        //   width: 300,
        //   height: 65,
        //   color: color,
        //   borderColor: borderColor
        // },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'checkbox',
          name: '複選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          inputType: 'radio',
          name: '單選框',
          label: '',
          width: 30,
          height: 30,
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'container',
          usertype: this.type,
          name: '容器',
          width: 300,
          height: 300,
          children: [],
          color: color,
          borderColor: borderColor
        },
        {
          disabled: true,
          type: 'input',
          usertype: this.type,
          placeholder: '請輸入',
          fieldname: undefined,
          inputType: 'input',
          name: '文字',
          width: 250,
          height: 40,
          color: color,
          borderColor: borderColor
        }
      ]
    }
  },
  methods: {
    /**
     * 處理拖曳事件
     * @param {Event} e - 拖曳事件對象
     * @param {Object} item - 被拖曳的元件數據
     */
    handleDrag(e, item) {
      e.dataTransfer.dropEffect = 'copy'
      e.dataTransfer.setData('text/component', JSON.stringify(item))
    }
  },
  // 渲染元件列表
  render() {
    return (
      <div class="vs-components">
        {this.components.map((item, index) => {
          return (
            <div
              ondragstart={(e) => this.handleDrag(e, item)}
              draggable="true"
              class="components-item"
              style={'background:' + item.color + ';color:black'}
              key={index}>
              {item.name}
            </div>
          )
        })}
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
.vs-components {
  // width: 200px;
  border-right: 1px solid #ececec;
  position: relative;
  overflow-y: scroll;
  background: #f8f8f8;

  &::-webkit-scrollbar {
    display: none;
  }

  .components-icon {
    width: 35px;
    height: 35px;
    margin-bottom: 6px;
  }
}

.components-item {
  margin-bottom: 0; // 移除底部間距，使用邊框代替
  height: 50px; // 增加高度，從 40px 改為 50px
  width: 100%;
  float: left;
  display: flex;
  border: 1px solid #dcdfe6; // 統一邊框樣式
  border-radius: 4px; // 統一圓角
  box-shadow: none !important; // 強制移除陰影效果
  margin-bottom: 8px; // 項目之間的間距

  // 移除舊的邊框樣式
  &:nth-child(2n + 1) {
    border-right: none; // 移除右側邊框
  }

  border-bottom: none; // 移除底部邊框（使用統一的邊框代替）

  align-items: center;
  justify-content: center;
  cursor: move;
  flex-direction: row; // 改為橫向排列
  font-weight: normal; // 統一字體粗細
  transition: all 0.2s ease;

  &:hover {
    border-color: #c0c4cc; // hover 時邊框稍微加深
    background: rgba(255, 255, 255, 0.8); // 輕微背景變化
  }
}
</style>
